export default {
  date (isoString) {
    if (isoString) {
      let date = new Date(isoString)
      return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + date.getHours() + ':' + date.getMinutes()
    } else {
      return ''
    }
  },
  time (isoString) {
    if (isoString) {
      let date = new Date(isoString)
      return date.getHours() + ':' + date.getMinutes()
    } else {
      return ''
    }
  },
  limitedTimeMount (isoString) {
    let date = new Date(isoString)
    return [[date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-'),
      [date.getHours(), date.getMinutes()].join(':')
    ].join(`  `).replace(/(?=\b\d\b)/g, '0')
  },
  // 金额小数点
  fixedPrice (val) {
    return Number(val).toFixed(2)
  },
  // 转换数值为.00的格式
  amountFormat (val) {
    // 保留2位小数
    let f = parseFloat(val)
    if (isNaN(f)) {
      return
    }
    f = Math.round(val * 100) / 100
    return f % 1 === 0 ? f + '.00' : f
  }
}
